import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  Botao,
  Carregando,
  ModalBase,
  PdfViewer,
  scrollParaTopo,
  TextAreaUnform,
  FormUnform,
  FormRef
} from 'src/componentes'
import { RotasApp } from 'src/rotas'
import { Api } from 'src/servicos'

import {
  ContainerAcoes,
  ContainerConteudoTermo,
  ContainerModalCancelar,
  ContainerPDFViewer
} from '../styles'

/**
 * Tela do Termo de Rescisão (§8 da PROPOSTA).
 * Exibida ao aluno quando o protocolo está em "Aguardando termo de rescisão".
 * É o único aceite que efetiva a rescisão.
 */
export const PaginaTermoRescisao: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const formRef = useRef<FormRef>(null)
  const [url, definirUrl] = useState<string>(null)
  const [carregando, definirCarregando] = useState(true)
  const [processando, definirProcessando] = useState(false)
  const [modalCancelarAberta, definirModalCancelarAberta] = useState(false)

  useEffect(() => {
    scrollParaTopo()

    const carregar = async () => {
      try {
        definirCarregando(true)
        const urlPdf = await Api.ObterTermoRescisao(id)
        definirUrl(urlPdf)
      } finally {
        definirCarregando(false)
      }
    }

    carregar()
  }, [id])

  const aceitar = async () => {
    try {
      definirProcessando(true)
      await Api.AceitarTermoRescisao(id)
      toast('Rescisão aceita. Você receberá as instruções por e-mail.', {
        type: 'success'
      })
      history.push(RotasApp.Home)
    } finally {
      definirProcessando(false)
    }
  }

  const cancelar = async (dados: { motivo: string }) => {
    if (!dados.motivo?.trim()) return

    try {
      definirProcessando(true)
      await Api.CancelarRescisaoAoVerTermo(id, dados.motivo.trim())
      toast('Rescisão cancelada. Sua matrícula foi mantida.', { type: 'info' })
      definirModalCancelarAberta(false)
      history.push(RotasApp.Home)
    } finally {
      definirProcessando(false)
    }
  }

  if (carregando) {
    return <Carregando texto="Carregando termo de rescisão..." />
  }

  return (
    <ContainerConteudoTermo>
      <h2>Termo de Rescisão</h2>
      <ContainerPDFViewer>
        <PdfViewer
          url={url}
          altura="900px"
          descricaoMobile="Clique no botão abaixo para baixar o termo de rescisão"
          nomeArquivo="termo-de-rescisao"
        />
      </ContainerPDFViewer>

      <ContainerAcoes>
        <Botao
          texto="Cancelar rescisão"
          tema="Secundario"
          type="button"
          disabled={processando}
          onClick={() => definirModalCancelarAberta(true)}
        />
        <Botao
          texto="Aceitar rescisão"
          type="button"
          carregando={processando}
          onClick={aceitar}
        />
      </ContainerAcoes>

      <ModalBase
        id="modal-cancelar-rescisao"
        aberta={modalCancelarAberta}
        backdrop
      >
        <ContainerModalCancelar>
          <h2>Cancelar rescisão</h2>
          <p>Conte-nos o motivo do cancelamento (obrigatório).</p>
          <FormUnform ref={formRef} acaoSucesso={cancelar}>
            <TextAreaUnform
              id="txt_motivo_cancelamento"
              name="motivo"
              label="Motivo do cancelamento"
              maxLength={2000}
            />
            <ContainerAcoes>
              <Botao
                texto="Voltar"
                tema="Secundario"
                type="button"
                disabled={processando}
                onClick={() => definirModalCancelarAberta(false)}
              />
              <Botao
                texto="Confirmar cancelamento"
                type="submit"
                carregando={processando}
              />
            </ContainerAcoes>
          </FormUnform>
        </ContainerModalCancelar>
      </ModalBase>
    </ContainerConteudoTermo>
  )
}

export default PaginaTermoRescisao
